import { Provider } from 'react-redux';
import store from './store'
import { RouterProvider } from 'react-router-dom';
import theme from './themes/theme';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from "@mui/material/styles";
import { PermissionProvider } from './pages/authentication/permission-providor/context/PermissionProvider';
import { Toaster } from "sonner";
import router from './routes';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <PermissionProvider>
          <CssBaseline />
           <Toaster position="bottom-center" closeButton richColors />
          <RouterProvider
            future={{
              v7_startTransition: true,
            }}
            router={router}
          />

        </PermissionProvider>
      </Provider>
    </ThemeProvider>

  );
}

export default App;
